<template lang="html">
  <div id="app">
    <div class="container-scroller" v-if="$auth.isAuthenticated">
      <app-header/>
      <div class="container-fluid page-body-wrapper">
        <app-sidebar/>
        <div class="main-panel">
          <div class="content-wrapper">
            <router-view></router-view>
          </div>
          <!-- content wrapper ends -->
          <app-footer/>
        </div>
        <!-- main panel ends -->
      </div>
      <!-- page-body-wrapper ends -->
    </div>
    <div id="login" v-if="!$auth.isAuthenticated && !$auth.loading">
      <app-login/>
    </div>
  </div>
</template>

<script lang="js">
import AppHeader from '../src/components/partials/AppHeader'
import AppSidebar from '../src/components/partials/AppSidebar'
import AppFooter from '../src/components/partials/AppFooter'
import AppLogin from '../src/components/partials/AppLogin'

export default{
  name: 'app',
  components: {
    AppHeader,
    AppSidebar,
    AppFooter,
    AppLogin
  }
}
</script>

<style>
  @import "../node_modules/@mdi/font/css/materialdesignicons.min.css";
  @import "../node_modules/font-awesome/css/font-awesome.min.css";
</style>

<style lang="scss">
@import "./assets/scss/style";
</style>



// WEBPACK FOOTER //
// src/App.vue